import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend';
import { exists } from '@nu-art/ts-common';
import { ModuleFE_Reference, resolveReferenceDisplay } from '../../../_entity.js';
import { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
import { ICONS, Preview } from '@app/styles';
import { Editor_Reference } from '../../_editors/reference/Editor_Reference.js';
import './Preview_Reference.scss';
export class Preview_Reference extends ComponentSync {
    static show = (referenceId, editMode, onUpsert) => {
        const reference = ModuleFE_Reference.cache.unique(referenceId);
        if (!reference)
            return ModuleFE_Toaster.toastError(`Could not open preview for reference, no item with id ${referenceId} found`);
        const model = {
            key: `preview-${referenceId}`,
            className: 'preview-window',
            rect: {
                ...windowRect.thirdScreen_Right(),
                height: undefined,
            },
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Preview_Reference, { reference: reference, closePreview: cb, editMode: editMode, onUpsert: onUpsert })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    static showNew = (acceptableTypes, onUpsert) => {
        const model = {
            key: 'preview-new-reference',
            className: 'preview-window',
            rect: {
                ...windowRect.thirdScreen_Right(),
                height: undefined,
            },
            moveable: true,
            resizable: true,
            content: cb => _jsx(Preview_Reference, { closePreview: cb, editMode: true, onUpsert: onUpsert, lockRefTypes: acceptableTypes })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    static copy = (reference, onUpsert) => {
        const model = {
            key: 'preview-new-reference',
            className: 'preview-window',
            rect: {
                ...windowRect.thirdScreen_Right(),
                height: undefined,
            },
            moveable: true,
            resizable: true,
            content: cb => _jsx(Preview_Reference, { closePreview: cb, reference: reference, editMode: true, onUpsert: onUpsert })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.editable = this.getEditable(nextProps.reference);
        state.editMode = nextProps.editMode ?? false;
        state.lockRefTypes = nextProps.lockRefTypes;
        return state;
    }
    // ######################### Logic #########################
    getEditable(_reference) {
        const reference = _reference?._id
            ? (ModuleFE_Reference.cache.unique(_reference._id) ?? {})
            : (_reference ?? {});
        return new EditableDBItemV3(reference, ModuleFE_Reference)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(ref => {
            this.forceUpdate();
            this.props.onUpsert?.(ref);
        })
            .setAutoSave(true);
    }
    resolveTitle = () => {
        if (exists(this.state.editable.item._id))
            return resolveReferenceDisplay(this.state.editable.item);
        return 'New Reference';
    };
    // ######################### Render #########################
    render() {
        return _jsxs(Preview.Root, { className: 'preview__reference', children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        const title = this.resolveTitle();
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: title }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.closePreview }) })] });
    };
    render_Main = () => {
        return _jsx(Preview.Main, { children: _jsx(Editor_Reference, { reference: this.state.editable, editMode: this.state.editMode, lockRefTypes: this.state.lockRefTypes }) });
    };
}
//# sourceMappingURL=Preview_Reference.js.map